import { useMemo } from "react";
import styles from "../../../../styles/NavigationLogs.module.css";
import { GetNavigationLogsDto } from "./types";

interface MetricCardsProps {
  logs: GetNavigationLogsDto[];
}

export const MetricCards = ({ logs }: MetricCardsProps) => {
  const metrics = useMemo(() => {
    const total = logs.length;
    const sessions = new Set(logs.map((l) => l.sessionId)).size;
    const withDur = logs.filter((l) => l.duration != null);
    const avgDur = withDur.length
      ? Math.round(withDur.reduce((a, b) => a + (b.duration ?? 0), 0) / withDur.length)
      : 0;
    const errors = logs.filter((l) => l.type === "ERROR").length;
    return { total, sessions, avgDur, errors };
  }, [logs]);

  return (
    <div className={styles.metricsGrid}>
      <MetricCard label="Total de eventos" value={metrics.total} />
      <MetricCard label="Sessões únicas" value={metrics.sessions} />
      <MetricCard label="Duração média" value={metrics.avgDur} suffix="ms" />
      <MetricCard
        label="Erros"
        value={metrics.errors}
        danger={metrics.errors > 0}
      />
    </div>
  );
};

interface MetricCardProps {
  label: string;
  value: number;
  suffix?: string;
  danger?: boolean;
}

const MetricCard = ({ label, value, suffix, danger }: MetricCardProps) => (
  <div className={styles.metricCard}>
    <div className={styles.metricLabel}>{label}</div>
    <div className={styles.metricValue} style={danger ? { color: "var(--red-11)" } : undefined}>
      {value}
      {suffix && <span className={styles.metricSuffix}>{suffix}</span>}
    </div>
  </div>
);
